import { SettingsType } from "building-types/settings/settingsType";
import type { StairCatalogSettings } from "building-types/settings/stairCatalogSettings";
import type { AssembledStair, GenericStair } from "building-types/stairs/stairConstruction";
import { STAIR_DEFAULT_MATERIAL, StairConstructionType, StringerLayout } from "building-types/stairs/stairConstruction";
import type { StairConfig, StairSetting } from "building-types/stairs/stairTypes";

export const STAIR_CUT_HEIGHT = 84;

export const defaultStairConstruction: GenericStair = {
  type: StairConstructionType.GENERIC,
  stairBottomOffset: 0,
  stringerTopExtension: 0,
  treadThickness: 1,
  treadMaterial: STAIR_DEFAULT_MATERIAL,
  hasRisers: true,
  riserThickness: 1,
  riserMaterial: STAIR_DEFAULT_MATERIAL,
  nosing: 0.5,
  hasTreadMaterial: false,
};

export const defaultStairConfig: StairConfig = {
  minTreadDepth: 11,
  maxTreadDepth: 11,
  desiredTreadDepth: 11,
  maxRiserHeight: 7.75,
  desiredRiserHeight: 7,
  landingDepth: 7,
  landingMaterial: STAIR_DEFAULT_MATERIAL,
  minimumClearWidth: 36,
  desiredRunWidth: 36,
  stringerPerpDepthFromStairNotch: 5,
  construction: defaultStairConstruction,
};

export const defaultAssembledStairConstruction: AssembledStair = {
  type: StairConstructionType.ASSEMBLED,
  stringerMinDepth: 10,
  stairBottomOffset: 0,
  stringerTopExtension: 0,
  stringerLayout: StringerLayout.AUTOMATIC,
  stringerThickness: 1.75,
  stringerSideOffset: 0,
  stringerMaxSpacing: 24,
  stringers: [],
  treadThickness: 1,
  treadMaterial: STAIR_DEFAULT_MATERIAL,
  hasRisers: true,
  riserThickness: 1,
  riserMaterial: STAIR_DEFAULT_MATERIAL,
  nosing: 0.5,
};

export const defaultAssembledStairConfig: StairConfig = {
  minTreadDepth: 11,
  maxTreadDepth: 11,
  desiredTreadDepth: 11,
  maxRiserHeight: 7.75,
  desiredRiserHeight: 7,
  landingDepth: 7,
  landingMaterial: STAIR_DEFAULT_MATERIAL,
  minimumClearWidth: 36,
  desiredRunWidth: 36,
  stringerPerpDepthFromStairNotch: 5,
  construction: defaultAssembledStairConstruction,
};

// TODO: Nathan/Andrew default keys here and in railing constants should be
// generated at runtime
export const defaultStairSettingsKey = "BpMdH2VrMYig3qhl";

export const defaultStairSettings: StairSetting = {
  catalogItemType: "STAIR_SETTING",
  entityType: "STAIR_SETTING",
  id: defaultStairSettingsKey,
  name: "Default Stair",
  config: defaultAssembledStairConfig,
  sortIndex: 0,
};

export const defaultStairCatalogSettings: StairCatalogSettings = {
  type: SettingsType.STAIR_CATALOG_SETTINGS,
  name: "Default Stair Catalog Settings",
  stairSettingsTable: {
    [defaultStairSettingsKey]: defaultStairSettings,
  },
};

export const TREAD_INTERSECTOR_HALF_WIDTH = 1000;

/**
 * minimum tread thickness allowed in model
 */
export const TREAD_MIN_DEPTH = 0.01;

export const EDGE_DETECTION_EPSILON = 0.001;

/**
 * pass this to mergeStairSystemProps to indicate
 * that StairBlocks will be regenerated, so any
 * selected StairBlocks should be deselected first
 * (default is NO_DESELECT_BLOCKS)
 */
export const NO_DESELECT_BLOCKS = false;
